import { FC } from 'react';
import { Box } from '@doda/io-react/common';
import styles from './index.module.scss';

/** アコーディオンリスト */
interface Props {
  /** メニューが開いているかどうか */
  isOpenMenu: boolean;
  /** children */
  children: React.ReactNode;
}

export const AccordionListWrapper: FC<Props> = ({ isOpenMenu, children }) => {
  return (
    <Box
      className={`${styles.accordionListWrapper} ${
        isOpenMenu ? styles.is_open : ''
      }`}
      color="white"
      boxShadow="blue"
    >
      {children}
    </Box>
  );
};
